import { Component } from "react";
import React from "react";

import { skills } from "../../shared/constants/skills";
import { pageConstatns } from "../../shared/constants/generalConstants";
import "./skillsStyle.scss";
import {
  OverlayTrigger,
  ProgressBar,
  Tooltip,
  Row,
  Col,
} from "react-bootstrap";
import VerticalLine from "../../shared/components/verticalLineComponent/verticalLine";
import BackComponent from "../../shared/components/backComponent/back";
import { withRouter } from "react-router-dom";

class Skills extends Component {
  state = { loadingValue: 0, firstLoad: true, underlineOnHover: false };
  static defaultProps = {
    verticalLineColVal: 1,
    mainColVal: 5,
  };

  startLoaderAnimation = () => {
    const interval = setInterval(() => {
      if (this.state.loadingValue < 100) {
        this.setState({
          loadingValue: this.state.loadingValue + 1,
        });
      } else {
        clearInterval(interval);
        this.setState({
          underlineOnHover: true,
        });
      }
    }, 2);
  };

  render() {
    const { verticalLineColVal, mainColVal } = this.props;
    const { loadingValue, firstLoad } = this.state;

    if (firstLoad) {
      this.startLoaderAnimation();
      this.setState({
        firstLoad: false,
      });
    }

    const SkillGroup = ({ skill, key }) => {
      return (
        <div className="skill" key={key}>
          <img
            className="skill__image"
            src={require(`../../public/static/${skill.icon}.${skill.iconType}`)}
            alt={`${skill.name}`}
          />
          <div className="skill__description">
            <span className="skill__name">{skill.name}</span>
            <span className="skill__percent">
              {skill.experiencePercent}{" "}
              {`${skill.experiencePercent ? "%" : ""}`}
            </span>
            <ProgressBar
              className="skill__progrress"
              animated
              now={
                loadingValue <= +skill.experiencePercent
                  ? loadingValue
                  : +skill.experiencePercent
              }
            />

            <span className="skill__projects__involved">
              Projects involved in: {skill.projectsWorkedOn}
              {!skill.areProjectsListed && (
                <OverlayTrigger
                  placement={"bottom"}
                  overlay={
                    <Tooltip>
                      Some of the projects that I worked on, cannot be
                      enumerated here, because of privacy imposed by the job or
                      by some clients.
                    </Tooltip>
                  }
                >
                  <img
                    className="skill__info__icon"
                    alt="Info Btn"
                    src={require(`../../public/static/icon--info.svg`)}
                  ></img>
                </OverlayTrigger>
              )}
            </span>
          </div>
        </div>
      );
    };

    return (
      <div className="container">
        <div className="stack__title--wrapper">
          <div className="stack__title--back">
            <BackComponent />
          </div>
          <div className="stack__title underline">Skills</div>
        </div>

        <Row>
          <Col
            sm={mainColVal}
            md={mainColVal}
            lg={mainColVal}
            className="stack__frontend"
          >
            {skills
              .filter((skill) => skill.stack === pageConstatns.frontEndStack)
              .map((skill, key) => (
                <SkillGroup skill={skill} key={key}></SkillGroup>
              ))}
          </Col>
          <Col
            sm={verticalLineColVal}
            md={verticalLineColVal}
            lg={verticalLineColVal}
            className=".stack__vertical__line"
          >
            <VerticalLine></VerticalLine>
          </Col>
          <Col
            sm={mainColVal}
            md={mainColVal}
            lg={mainColVal}
            className="stack__backend"
          >
            {skills
              .filter((skill) => skill.stack === pageConstatns.backendStack)
              .map((skill, key) => (
                <SkillGroup skill={skill} key={key}></SkillGroup>
              ))}
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(Skills);
